/*
  Данная утилита форматирует числовое значение взависимости от переданных thousandsSeparator и decimalSeparator
  Мы не используем toLocaleString, т.к в виджете калькулятор thousandsSeparator, decimalSeparator задаются на уровне виджета
*/

export function formatNumberWithCustomSeparator(
  value: number | string,
  thousandsSeparator = ',',
  decimalSeparator = '.'
) {
  if (!value) return value;

  const [integer, decimal] = String(value).replaceAll(',', '.').split('.');
  const integerByThousands = integer.replace(
    /(\d)(?=(?:\d{3})+(?:\.|$))/g,
    `$1${thousandsSeparator}`
  );

  if (!decimal) {
    return integerByThousands;
  }

  return [integerByThousands, decimal].join(decimalSeparator);
}
